import { useInfiniteQuery } from 'coreOld/hooks';
import { inventoryService } from 'partsOld/services';
import { IInventory } from 'partsOld/types';

export const useGetInventoryList = (filters?) =>
  useInfiniteQuery<IInventory>(inventoryService.getMany, 'inventoryList', filters);
